import React from 'react'

const Wmv = ({ viewBox }) => (
  <svg viewBox={viewBox}>
    <path
      fill="#E9E9E0"
      d="M38.111,1.668H8.73c-0.818,0-1.481,0.664-1.481,1.95V57.35c0,0.349,0.663,1.012,1.481,1.012H49.3
	c0.818,0,1.482-0.663,1.482-1.012V14.807c0-0.705-0.096-0.931-0.261-1.099l-11.78-11.78C38.574,1.762,38.347,1.668,38.111,1.668z"
    />
    <polygon
      fill="#D9D7CA"
      points="38.633,1.822 38.633,13.817 50.628,13.817 "
    />
    <path
      fill="#7D6599"
      d="M49.3,58.362H8.73c-0.818,0-1.481-0.663-1.481-1.48V41.152h43.533v15.729
	C50.782,57.698,50.118,58.362,49.3,58.362z"
    />
    <path
      fill="#FFFFFF"
      d="M34.013,45.123H35.7v10.201h-1.688v-7.018l-2.285,5.675h-1.466l-2.298-5.675v7.018h-1.689V45.123h1.689
	l3.031,6.977L34.013,45.123z"
    />
    <path
      fill="#FFFFFF"
      d="M24.528,45.123L21.773,55.38h-2.159l-1.675-7.696l-1.785,7.696H13.98l-2.587-10.257h1.882l1.798,8.803
	l1.938-8.803h1.882l1.799,8.803l1.952-8.803H24.528z"
    />
    <g>
      <path
        fill="#C8BDB8"
        d="M35.588,14.936l-0.717-0.715c-2.103-2.104-4.9-3.263-7.875-3.263s-5.771,1.159-7.875,3.263
		c-2.103,2.102-3.262,4.899-3.262,7.874c0,2.975,1.159,5.772,3.262,7.875c2.104,2.104,4.901,3.262,7.875,3.262
		s5.772-1.158,7.875-3.262l0.717-0.716l-7.159-7.159L35.588,14.936z M32.685,29.214c-1.61,1.292-3.595,1.992-5.688,1.992
		c-2.434,0-4.722-0.947-6.442-2.668c-1.721-1.721-2.669-4.009-2.669-6.443c0-2.433,0.948-4.722,2.669-6.442
		c1.72-1.721,4.009-2.669,6.442-2.669c2.093,0,4.078,0.701,5.688,1.993l-7.119,7.118L32.685,29.214z"
      />
      <path
        fill="#C8BDB8"
        d="M36.108,21.082h-3.038c-0.56,0-1.012,0.452-1.012,1.012s0.452,1.013,1.012,1.013h3.038
		c0.56,0,1.012-0.453,1.012-1.013S36.668,21.082,36.108,21.082z"
      />
      <path
        fill="#C8BDB8"
        d="M42.183,21.082h-2.024c-0.561,0-1.014,0.452-1.014,1.012s0.453,1.013,1.014,1.013h2.024
		c0.56,0,1.013-0.453,1.013-1.013S42.742,21.082,42.183,21.082z"
      />
    </g>
    <circle fill="#C8BDB8" cx="25.724" cy="16.916" r="2.025" />
    <path
      fill="#FFFFFF"
      d="M40.705,55.34l-3.117-10.083h1.864l2.327,8.653l2.464-8.653h1.85L42.827,55.34H40.705z"
    />
  </svg>
)

export default Wmv



// WEBPACK FOOTER //
// ./src/components/Svg/wmv.js